var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sms-action-footer"},[_c('div',{staticClass:"close-sms-action",on:{"click":function($event){return _vm.$emit('closeAction')}}},[_c('span',{staticClass:"close"},[_vm._v("close")])]),_vm._v(" "),_vm._t("footerRight")],2)}
var staticRenderFns = []

export { render, staticRenderFns }